import { SessionManager, configure } from '@mysidewalk/session-manager';

import { ROOT_DOMAIN, PROTOCOL } from '../settings';

configure({ domain: ROOT_DOMAIN, protocol: PROTOCOL });
export default new SessionManager();
